var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.$store.getters.GET_LOADING,
          expression: "$store.getters.GET_LOADING",
        },
      ],
      staticClass: "login-page",
    },
    [
      _c("div", { staticClass: "login-page-title" }, [
        _c("div", [_vm._v(_vm._s(_vm.$t("welcome_anycubic_slicer")))]),
        _c("div", [_vm._v(_vm._s(_vm.$t("add_printers_manage_jobs")))]),
      ]),
      _c("div", { staticClass: "login-page-main" }, [
        _c("div", { staticClass: "login-page-main-item" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/imgs/remote-printing.png"),
              alt: "",
            },
          }),
          _c("div", { staticClass: "login-page-main-item-title" }, [
            _vm._v(_vm._s(_vm.$t("remote_printing"))),
          ]),
          _c("div", { staticClass: "login-page-main-item-describe" }, [
            _vm._v(_vm._s(_vm.$t("connect_printer_slicer_wan"))),
          ]),
        ]),
        _c("div", { staticClass: "login-page-main-item" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/imgs/get-notifications.png"),
              alt: "",
            },
          }),
          _c("div", { staticClass: "login-page-main-item-title" }, [
            _vm._v(_vm._s(_vm.$t("get_notifications"))),
          ]),
          _c("div", { staticClass: "login-page-main-item-describe" }, [
            _vm._v(_vm._s(_vm.$t("receive_notifications"))),
          ]),
        ]),
        _c("div", { staticClass: "login-page-main-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/imgs/video-monitor.png"), alt: "" },
          }),
          _c("div", { staticClass: "login-page-main-item-title" }, [
            _vm._v(_vm._s(_vm.$t("video_monitor"))),
          ]),
          _c("div", { staticClass: "login-page-main-item-describe" }, [
            _vm._v(_vm._s(_vm.$t("video_monitor_real_time"))),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "login-page-btn-box" }, [
        _c(
          "div",
          { staticClass: "login-page-btn", on: { click: _vm.loginHandle } },
          [_vm._v(_vm._s(_vm.$t("Login")))]
        ),
        _c(
          "div",
          {
            staticClass: "login-page-btn",
            on: {
              click: function ($event) {
                _vm.addDialog = true
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("AddPrinter")))]
        ),
      ]),
      _c("addPrinter", {
        attrs: { visible: _vm.addDialog },
        on: {
          "update:visible": function ($event) {
            _vm.addDialog = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }